import axios from "axios";
import { environmentConfig } from "@/config/enviromentConfig";
import store from "@/store";

export default class PredictorService {
    static getProductId() {
        return store.state.brandConfig ? store.state.brandConfig.productId || 56 : 56;
    }

    static async getActiveSports(msisdn, username) {
        const response = await axios.post(`${environmentConfig.predictorService}/player-landing-page`, {
            msisdn: msisdn,
            username: username,
            leagueXI: 1,
            productId: 310
        });
        return response.data;
    }

    static async getUserStats(msisdn) {
        const response = await axios.post(`${environmentConfig.predictorService}/get-user-stats`, {
            msisdn: msisdn,
            promo: 0,
            leagueXI: 1,
            productId: 310
        });
        return response.data;
    }

    static async getPlayerResults(msisdn) {
        return await axios.post(`${environmentConfig.predictorService}/get-players-winnings`, {
            msisdn: msisdn,
            productId: this.getProductId()
        });
    }

    static async getPlayerRoundPredictions(msisdn, roundId) {
        const response = await axios.post(`${environmentConfig.predictorService}/get-player-round-predictions`, {
            msisdn: msisdn,
            roundId: roundId,
            leagueXI: 1,
            productId: 310
        });
        return response.data;
    }

    static async getPlayerRoundHistory(msisdn) {
        const response = await axios.post(`${environmentConfig.predictorService}/get-player-round-history`, {
            msisdn: msisdn,
            productId: 310,
            sportId: 1,
            promo: 0,
            free: 0,
            leagueXI: 1,
        });
        return response.data;
    }

    static async enterPredictions(msisdn, predictions, roundId) {
        return await axios.post(`${environmentConfig.predictorService}/football/enter-predictions`, {
            msisdn: msisdn,
            roundId: roundId || store.state.roundId,
            predictions: predictions,
            productId: this.getProductId()
        });
    }

    static async getRoundLeaderboard(msisdn, roundId) {
        return await axios.post(`${environmentConfig.predictorService}/get-leaderboard`, {
            msisdn: msisdn,
            roundId: roundId,
            productId: this.getProductId(),
            leagueXI: 1,
        });
    }

    static async getLeagueFixtures(msisdn, roundId) {
        return await axios.post(`${environmentConfig.predictorService}/round-fixtures`, {
            msisdn: msisdn,
            roundId: roundId,
            productId: 310,
            leagueXI: 1
        });
    }

    static async getUpcomingFixturesByLeague() {
        const response = await axios.post(`https://fantasysoccer.vodacomfantasy.com/api/fixtures/get-upcoming-fixtures`, {
            sportId: 1
        });
        return response.data;
    }

    static async getSoccerStandings(leagueAbbreviation) {
        const response = await axios.post(`https://fantasysoccer.vodacomfantasy.com/game-engine/fixtures/get-soccer-standings`, {
            leagueAbriviation: leagueAbbreviation
        });
        return response.data;
    }

    static async enterStatPredictions(msisdn, roundId, soccerFixtureId, mostSavesTeamId, mostPossessionTeamId, mostYellowCardsTeamId, mostCornersTeamId) {
        const response = await axios.post(`${environmentConfig.predictorService}/soccer/enter-stat-predictions`, {
            msisdn: msisdn,
            roundId: roundId,
            soccerFixtureId: soccerFixtureId,
            mostSavesTeamId: mostSavesTeamId,
            mostPossessionTeamId: mostPossessionTeamId,
            mostYellowCardsTeamId: mostYellowCardsTeamId,
            mostCornersTeamId: mostCornersTeamId,
            productId: 310
        });
        return response.data;
    }

    static async getUpcomingRounds(msisdn) {
        const response = await axios.post(`${environmentConfig.predictorService}/get-upcoming-rounds`, {
            msisdn: msisdn,
            productId: this.getProductId()
        });
        return response.data;
    }
}
